import React, { useState, useEffect } from 'react';

import UserLayout from '../../../../components/user-layout/UserLayout';
import styles from './ticketMgmt.module.scss';
import ticketService from '../../../../utils/services/ticketService';
import authService from '../../../../utils/services/authService';
import { NavLink } from 'react-router-dom';

const TicketMgmt = () => {
  const [tickets, setTickets] = useState();
  const [filteredTickets, setFilteredTickets] = useState();
  const [selected, setSelected] = useState();

  const userData = authService.getUserData();

  useEffect(() => {
    ticketService.getAllTickets(userData).then((res) => {
      if (res.data.success) {
        setTickets(res.data.data);
      }
    });
  }, []);

  useEffect(() => {
    if (selected !== undefined) {
      setFilteredTickets(filterTickets(tickets));
    }
  }, [selected]);

  const selectHandle = (e) => {
    e.preventDefault();
    const value = e.target.value;
    setSelected(value);
  };

  const filterTickets = (tickets) => {
    const filtered = tickets.filter((ticket) => ticket.category === selected);
    return filtered;
  };
  return (
    <UserLayout>
      <section className={styles.ticketsWrapper}>
        <h1 className={styles.ticketsWrapper_heading}>Tickets</h1>
        <section className={styles.ticketSelection}>
          <button
            className={`${styles.ticketSelection_btn} ${
              selected === 'technical' ? styles.active : ''
            }`}
            value="technical"
            onClick={(e) => {
              selectHandle(e);
              filterTickets(tickets);
            }}
          >
            Technical
          </button>
          <button
            className={`${styles.ticketSelection_btn} ${
              selected === 'account' ? styles.active : ''
            }`}
            value="account"
            onClick={(e) => {
              selectHandle(e);
            }}
          >
            Account
          </button>
          <button
            className={`${styles.ticketSelection_btn} ${
              selected === 'bugs' ? styles.active : ''
            }`}
            value="bugs"
            onClick={(e) => {
              selectHandle(e);
            }}
          >
            Bugs
          </button>
        </section>

        <section className={styles.ticketDisplay}>
          {tickets &&
            (!selected
              ? tickets?.map((ticket, index) => (
                  <NavLink
                    key={index}
                    to={`/admin/tickets/${ticket._id}`}
                    className={styles.link}
                  >
                    <div className={styles.ticketCard}>
                      <h4 className={styles.ticketCard_subject}>
                        {ticket.subject}
                      </h4>
                      <p className={styles.ticketCard_category}>
                        {ticket.category}
                      </p>
                      <p className={styles.ticketCard_createdAt}>
                        {ticket.createdAt}
                      </p>
                    </div>
                  </NavLink>
                ))
              : filteredTickets?.map((ticket, index) => (
                  <NavLink
                    key={index}
                    to={`/admin/tickets/${ticket._id}`}
                    className={styles.link}
                  >
                    <div className={styles.ticketCard}>
                      <h4 className={styles.ticketCard_subject}>
                        {ticket.subject}
                      </h4>
                      <p className={styles.ticketCard_category}>
                        {ticket.category}
                      </p>
                      <p className={styles.ticketCard_createdAt}>
                        {ticket.createdAt}
                      </p>
                    </div>
                  </NavLink>
                )))}
        </section>
      </section>
    </UserLayout>
  );
};

export default TicketMgmt;
